import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

import { FlightsResponsiveMessage } from 'types/shared/flights-responsive-message';

export class PageTitleStore extends Store {
  @observable public date?: FlightsResponsiveMessage;
  @observable public subTitle?: FlightsResponsiveMessage;
  @observable public title: FlightsResponsiveMessage;
  @observable public loading: boolean;
  @observable public pageAccessibility?: string;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setLoading(isNewSearch: boolean): void {
    if (isNewSearch) {
      this.loading = true;
    }
  }
}

PageTitleStore.DEFAULTS = {
  loading: true
};
